import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getCategories = async (config = {}) => {
  const res = await axiosInstance.get('productcategory/get-product-categories', config);
  return res.data;
};

export const getCategoryById = async (id) => {
  const res = await axiosInstance.get(`productcategory/get-product-category/${id}`);
  return res.data;
};

export const addCategory = async (category, config = {}) => {
  const res = await axiosInstance.post('productcategory/add-product-category', category, config);
  return res.data;
};

export const updateCategory = async (id, categoryName) => {
  const res = await axiosInstance.put('productcategory/update-product-category', {
    id,
    categoryName
  });
  return res.data;
};

export const deleteCategory = async (id) => {
  const res = await axiosInstance.delete(`productcategory/delete-product-category/${id}`);
  return res.data;
};